var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enroll-detail"},[_vm._v("\n  Hi all\n")])}
var staticRenderFns = []

export { render, staticRenderFns }